export class CouponModel {
    coupon_no: number
    coupon_name: string
    last_clear_date: string
    date_added: string
    active: boolean
    clinic_no: number

    constructor(
        coupon_no: number,
        coupon_name: string,
        last_clear_date: string,
        date_added: string,
        active: boolean,
        clinic_no: number,
    ) {
        this.coupon_no = coupon_no
        this.coupon_name = coupon_name
        this.last_clear_date = last_clear_date
        this.date_added = date_added
        this.active = active
        this.clinic_no = clinic_no
    }
}